export default {
  dms: {
    dmsKey: {
      id: 'Id',
      chooseDate: 'Tarih giriniz!',
      textArea: 'Döküman içeriği giriniz!',
      name: 'Name',
      description: 'Description',
      title: 'Title',
      active: 'Active',
      archive: 'Archive',
      actions: 'Actions',
      edit: 'Edit',
      fromDate: 'Başlangıç Tarihi',
      thruDate: 'Bitiş Tarihi',
      documentKeyDialogTitle: 'Parameter Definition',
      documentKeyTypeDialogTitle: 'Document Type Description',
      documentKeyIndexDialogTitle: 'Document Index Key Description',
      documentKeyIndex: 'Document Index Type',
      customerIdMustBeMandatory: 'Customer id must be mandatory!',
      someIndiciesMustBeMandatory: 'Atleast one index must be mandatory!',
      save: 'Save',
      delete: 'Delete',
      DocumentKeyTypeName: 'Document Key Type Name',
      Mandatory: 'Mandatory',
      deleteQuestion: 'Are you sure to delete this item?',
      valCategoryType: 'Document key description is required.',
      valCategoryNameRequired: 'Document key name is required.',
      valCategoryName: 'Characters must be 2 between 250.',
      valCategoryDescription: 'Characters must be 2 between 250.',
      documentTypeName: 'Document Type'
    },
    error: {
      fileshouldbeimage: 'All files should be image!'
    },
    documentType: {
      name: 'Name',
      description: 'Description',
      fromDate: 'From Date',
      thruDate: 'Thru Date',
      documentTypeDialogTitle: 'Document Type Name Description',
      deleteQuestion: 'Are you sure to delete this item?',
      valCategoryType: 'Document type description is required.',
      valCategoryNameRequired: 'Document type name is required.',
      valCategoryName: 'Characters must be 2 between 250.',
      valCategoryDescription: 'Characters must be 2 between 250.'
    }
  }
};